import PropTypes from 'prop-types';
import React from 'react';
import {
  Alert,
  Button,
  Image,
} from 'react-bootstrap';
import EventIcon from './EventIcon';
import PlaceDetail from './PlaceDetail';
import { EVENT_NAMES } from './EventStyles';
import { formalDate } from '../../../core/date';
import { Right } from 'react-bootstrap/lib/Media';
import UploadFormModal from './UploadFormModal ';
import { host } from '../../../config';
import { getHeaders } from '../../../core/api';
import logo from '../../../../public/new.gif';

const EventDate = (event) => {
  if (event.event_type === 'stay' || event.event_type === 'nost') {
    return `${formalDate(event.start)} - ${formalDate(event.end)}`;
  }
  return formalDate(event.start);
};

function formatRelatedEvent(event, events) {
  const name = event.group_name;
  let location = `${event.place.city} ${event.place.state}`;
  let hotel = 'No hotel booked!!!';

  if (event.event_type === 'nost') {
    hotel = 'No hotel needed.';
  }
  if (event.bids.hotel) {
    hotel = event.bids.hotel.name;
    location = `${event.bids.hotel.city}, ${event.bids.hotel.state}`;
  }
  events.push((
    <div className="col-sm-6">
      <p><strong>{name}</strong></p>
      <p>{hotel}</p>
      <p>{location}</p>
      <p>{ EventDate(event) }</p>
    </div>
  ));
}

async function  fetchdata(tourId,bidId){
  try{
  const event_id = null
  const group_id = null
  const upload_type = 'Accept bid'
  const tour_id = tourId
  const data = await fetch(`${host}/api/participants_documents/get_documents_by_tour/?tour_id=${tour_id}&upload_type=${upload_type}&bid_id=${bidId}&event_id=${event_id}&group_id=${group_id}`,{
    headers: getHeaders(),
    method: 'GET',
  })
  const json = await data.json()
  return json
  }
  catch(error){
    console.log(error)
  }
}
class EventDetail extends React.Component {
  constructor(props){
    super(props);
    this.state={
      uploadForm:false,
      bidIds:[],
      showFormBtn:true,
      showIndication:false
    }
    this.uploadFormModalPopup = this.uploadFormModalPopup.bind(this);
  }
  componentDidMount(){
    const { event,proposals } = this.props;
    const tempbidIds=[]
    let count=0
    proposals.map((item)=>{
      event.related_group_events.map((eventItem)=>{
        try{
          if(eventItem.bids.hotel?true:false){
            count+=1
            item.bids.map((itemBid)=>{
              if(itemBid.hotel.name===eventItem.bids.hotel.name){
                tempbidIds.push(itemBid.id)
              }
            })
          }
        }
        catch(error){
          console.log(error)
        }
      })
    })
    if(count === 0 ){
      this.setState({showFormBtn:false})
    }
    this.setState({
      bidIds:tempbidIds
    },()=>{
      fetchdata(this.props.tours.id, tempbidIds).then(data => {
        if(data.length > 0){
          this.setState({
            showIndication: true
          });
        }
      }).catch(error => {
        // Handle any errors here
        console.error('Error fetching data:', error);
      });
    })
  }

  uploadFormModalPopup=()=>{
    this.setState({uploadForm:true})
  }
  closeModal=()=>{
    this.setState({uploadForm:false})
  }
  render() {
    const { event } = this.props;
    const alerts = [];
    const showVenueMisMatchAlert = (
      <Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
        <h4>Venue information missing!</h4>
        <p>
        This show is connected to city location instead of venue.
        Your hotel search will be centered the city center instead of the venue.
        This often happens on imports when the venue is misspelled or missing from our database.
        </p>
        <p>
          <Button onClick={this.handleAlertDismiss}>Hide Alert</Button>
        </p>
      </Alert>
    );
    if (event.event_type === 'show' && event.place.place_type !== 'VENUE') {
      alerts.push(showVenueMisMatchAlert);
    }
    const related = [];
    if (event.event_type === 'stay') {
      const relatedEvents = event.related_group_events;
      for (let i = 0, len = relatedEvents.length; i < len; i++) {
        formatRelatedEvent(relatedEvents[i], related);
      }
    }
    const name = event.name ? event.name : EVENT_NAMES[event.event_type];


    return (
      <div className="container">
        { alerts.length !== 0 && (
          <div className="row"><div className="col-md-8">{alerts}</div></div>)
        }
        <div className="row">
          <div className="col-md-4">
            <h4><EventIcon eventType={event.event_type} />{name}</h4>
            <p>{ EventDate(event) }</p>
            { event.place.image && (<Image src={event.place.image} responsive />) }
          </div>
          <div className="col-md-4">
            <h4>Location</h4>
            <PlaceDetail place={event.place} />
            <div>
              {this.state.showFormBtn &&(
                <div>
                <Button bsStyle="success" onClick={this.uploadFormModalPopup} >Hotel Stay Documents</Button>
                {this.state.showIndication&&(
                   <img style={{width:'8%',marginBottom:'20px'}} className="sidebar-img" src={logo} alt="CATCH" />
                  )}
                </div>
              ) }
            </div>
          </div>
        </div>
        <div className="row">
          {related}
        </div>
        <div className="row">
          <div className="col-md-8">
            <h4>Notes</h4>
            <div className="panel panel-default">
              {event.notes}
            </div>
          </div>
        </div>
        {this.state.uploadForm && (
          <UploadFormModal 
            bidIds={this.state.bidIds}
            model_type={'Accept Docs'}
            upload_type={'Accept bid'}
            tour={this.props.tours}
            show={this.state.uploadForm}
            onClose={this.closeModal}
           />
        )}
      </div>
    );
  }
}


EventDetail.propTypes = {
  event: PropTypes.object.isRequired,
  // sendProposal: PropTypes.func.isRequired,
};

export default EventDetail;



// WEBPACK FOOTER //
// src/routes/tours/components/EventDetail.js